import React from 'react';
import {
  type RouteProp,
  useIsFocused,
  useRoute,
} from '@react-navigation/native';

import { MenuContent, useMenuContentData } from '../../components';
import type { MenuTabStackParamList } from '../../navigation/AppNavigation.props';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuScreen = () => {
  //
  // ─── Navigation ──────────────────────────────────────────────────────

  const { params } = useRoute<RouteProp<MenuTabStackParamList, 'Menu'>>();

  const { restaurantSlug } = params ?? {};

  // ─── Remote Data ─────────────────────────────────────────────────────

  const { restaurantData, isFetching, hasError, hasNoProducts } =
    useMenuContentData({ restaurantSlug });

  // ─────────────────────────────────────────────────────────────────────

  const isScreenFocused = useIsFocused();
  const shouldRenderErrorView = hasError || !restaurantData || hasNoProducts;

  // When the menu screen is rendered without being focused, there won't be any data available.
  const isWaitingForFocus = !isScreenFocused && shouldRenderErrorView;

  if (isFetching || isWaitingForFocus) {
    return <MenuContent.Loading />;
  }

  if (shouldRenderErrorView) {
    return <MenuContent.Error />;
  }

  // ─────────────────────────────────────────────────────────────────────

  const orderChannel = restaurantData.isOutpost ? 'outpost' : 'pickup';
  const locationName = restaurantData.name;

  return (
    <MenuContent.Ready
      // NOTE: We use the restaurant ID as the key to force a re-render when
      //       the restaurant data changes to prevent having a stale data and components.
      key={restaurantData.id}
      restaurantData={restaurantData}
      orderChannel={orderChannel}
      locationName={locationName}
    />
  );
};
